import type { DriveStep } from 'driver.js';
import type { IntlShape } from 'react-intl';
import { anchorSelector, findAnchor } from './anchors';
import type { TourStep } from './tours';

interface ResolveOptions {
    intl: IntlShape;
    values: Record<string, string>;
}

export function resolveSteps(steps: TourStep[], { intl, values }: ResolveOptions): DriveStep[] {
    return steps.filter((step) => {
        const element = findAnchor(step.anchor);
        if (!element || !element.getClientRects().length) return false;
        const { visibility } = getComputedStyle(element);
        return visibility !== 'hidden' && visibility !== 'collapse';
    }).map((step) => ({
        element: anchorSelector(step.anchor),
        disableActiveInteraction: step.mode === 'look',
        popover: {
            title: intl.formatMessage(step.title, values),
            description: intl.formatMessage(step.body, values),
            side: step.side,
            align: step.align,
        },
    }));
}
